var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.animation)?_c('lottie-animation',{ref:"anim",attrs:{"animationData":require(("../../assets/animation/" + _vm.animation + ".json")),"loop":true,"autoPlay":true,"speed":_vm.speed}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }